import { getValuationMarket, VALUATION_MARKETS } from './spanishMarket';

// Returns the Mapbox `country` filter to use for address geocoding/autocomplete.
//
// Rules:
//   - On the Spanish Bodex market (bodex.es, bodex.se/spanien,
//     bodex.no/spania, or bodex.dk/spanien) the country is
//     ALWAYS `es`, regardless of the active UI language. Otherwise a visitor
//     browsing in Swedish/Norwegian would get the home-market autocomplete
//     results, which is the wrong market.
//   - On bodex.no outside /spania the country is `no`.
//   - On bodex.dk outside /spanien the country is `dk`.
//   - On bodex.se outside /spanien the country is `se`.
export const getMapboxCountry = () => {
  const market = getValuationMarket();
  if (market === VALUATION_MARKETS.SPAIN) return 'es';
  if (market === VALUATION_MARKETS.NORWAY) return 'no';
  if (market === VALUATION_MARKETS.DENMARK) return 'dk';
  return 'se';
};

export const getMapboxLanguage = (language) => {
  const normalized = String(language || '').toLowerCase();
  if (normalized === 'dk') return 'da';
  if (normalized === 'no') return 'nb';
  return normalized || 'en';
};
